import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import EmployeeTimesheetResponseStatus from 'payroll/components/CellRenderers/EmployeeTimesheetResponseStatus';

const useEmployeeApprovedColumn = () => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) return null;

    return EmployeeTimesheetResponseStatus({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      field: 'employeeApproved',
      headerName: t('employeeStatus'),
      width: 130,
      sortable: false,
      initialHide: true,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useEmployeeApprovedColumn;
